module.exports = __webpack_public_path__ + "static/media/fourteenth_the_inn5.b7594714.png";